module.exports = __webpack_public_path__ + "static/media/golfer-8-b.77f76f5e.png";